import { render, staticRenderFns } from "./cargoInform.vue?vue&type=template&id=c8b446fc"
import script from "./cargoInform.vue?vue&type=script&lang=js"
export * from "./cargoInform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports